import { getRefreshPageStore } from '../modules/refreshPage';

export const RefreshPageStore = getRefreshPageStore();
